/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Reverse_Eleven_FramesInputs */



/**
* | output |
* | --- |
* | "Reverse 11 Frame" |
*
* @param {Shortcut_Keys_Name_Reverse_Eleven_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_reverse_eleven_frames = /** @type {((inputs?: Shortcut_Keys_Name_Reverse_Eleven_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Reverse_Eleven_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Reverse 11 Frame")
	if (locale === "de") return /** @type {LocalizedString} */ ("Reverse 11 Frame")
	if (locale === "it") return /** @type {LocalizedString} */ ("Reverse 11 Frame")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Reverse 11 Frame")
	if (locale === "es") return /** @type {LocalizedString} */ ("Reverse 11 Frame")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Reverse 11 Frame")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Reverse 11 Frame")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Reverse 11 Frame")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Reverse 11 Frame")
	return /** @type {LocalizedString} */ ("Reverse 11 Frame")
});